import { ref } from 'vue'

const toasts = ref([])

export function useToast() {
  const addToast = ({ title, message, type = 'success', duration = 3000 }) => {
    const id = Date.now() + Math.random()
    toasts.value.push({ id, title, message, type })
    
    if (duration > 0) {
      setTimeout(() => {
        removeToast(id)
      }, duration)
    }
  }

  const removeToast = (id) => {
    toasts.value = toasts.value.filter(toast => toast.id !== id)
  }

  return {
    toasts,
    addToast,
    removeToast
  }
}
